import ReactDOM from 'react-dom/client'
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import store from "./_store/store";
import { Provider } from "react-redux";
import ChunkLoadErrorBoundary from "src/components/common/ChunkLoadErrorBoundary";
import { registerInstallPromptListener } from "src/_utils/installPrompt";

// Must run before React renders — Chrome can fire `beforeinstallprompt` that early.
registerInstallPromptListener();

ReactDOM.createRoot(document.getElementById('root')).render(
  <ChunkLoadErrorBoundary>
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </ChunkLoadErrorBoundary>
)

/*
 * Register the service worker that makes the app installable (PWA).
 *
 * The worker itself is intentionally inert. It registers an EMPTY 'fetch'
 * handler — required by Chrome before it will offer to install the app — that
 * never calls event.respondWith(), so every request goes to the network
 * untouched and nothing is ever cached. See public/service-worker.js.
 *
 * Registered on 'load' so it never competes with app bootstrap, and only in
 * production builds — which means `yarn dev` will NOT exercise this path.
 * To test it locally use `yarn dev-server` (build + server.js), which mirrors
 * production.
 *
 * To disable the PWA later, do NOT delete public/service-worker.js — replace
 * its body with `self.registration.unregister()` and ship that first. A missing
 * file is served as index.html (HTTP 200, text/html) by the catch-all in
 * server.js, which breaks registration and strands already-installed workers.
 */
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch((error) => {
      // Registration failure must never affect the app — it only costs installability.
      console.warn("Service worker registration failed:", error);
    });
  });
}
